import React from "react";
import DistributorBalanceReport from "./DistributorBalanceReport";

const DistributorPayableReport = () => <DistributorBalanceReport mode="payable" />;

export default DistributorPayableReport;
